import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/customer';
import DataGrid from 'react-datagrid';
import { default as Config } from '../../config';

let columns = [
	{ name: 'nr', 'title': 'Numer faktury', textAlign: 'center'},
	{ name: 'date_issue', 'title': 'Data wystawienia', textAlign: 'center'},
	{ name: 'date_payment', 'title': 'Data płatności', textAlign: 'center'},
	{ name: 'sum_net_price', 'title': 'Kwota netto', textAlign: 'center', render: function(value){
		return (
			value + ' zł'
		);
	}},
	{ name: 'sum_gross_price', 'title': 'Kwota brutto', textAlign: 'center', render: function(value){
		return (
			value + ' zł'
		);
	}},
	{ name: 'status_payment', 'title': 'Płatność', textAlign: 'center', width: 100, render: function(status){
		return (
			<i className={status ? 'chevron circle down icon green' : 'remove circle icon red'}></i>
		);
	}},
	{ name: 'id', 'title': 'Operacje', textAlign: 'center', width: 100, render: function(id, data){
		return 	(
			<div>
				<a href="" onClick={(event) => {
					event.preventDefault(); 
					window.open(Config.apiUrl+'customer/generate-invoice/'+id+'?access-token='+localStorage.getItem('token'));
				}} title="Generuj fakturę">
					<i className="file pdf outline icon"></i>
				</a>
			</div>
		);
	}}
];

export let CustomerInvoice = React.createClass({
	displayName: 'CustomerInvoice',
	render: function(){
		return (<div className="">
			<div className="">
				<h2 className=""> Lista faktur</h2>
				<DataGrid idProperty="id" dataSource={this.props.actions.fetchInvoices} columns={columns} />
			</div>
		</div>);
	}
});

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerInvoice);


/** WEBPACK FOOTER **
 ** ./js/views/customer/Invoice.js
 **/